import Chat from 'entities/Chat';
import cx from 'classnames';
import HumanArray from 'components/HumanArray.jsx';
import Link from 'components/Link.jsx';
import Modal from 'components/Modal.jsx';
import React from 'react';
import Text from 'components/Text.jsx';

import './styles/ConversationHeader.scss';

const ConversationHeader = React.createClass({
  propTypes: {
    chat: React.PropTypes.instanceOf(Chat),
    title: React.PropTypes.string,
    subtitle: React.PropTypes.string,
    onTitleClicked: React.PropTypes.func,
  },

  getInitialState() {
    return {
      partner: this.props.chat && this.props.chat.getOtherChatMembers()[0],
    };
  },

  componentWillUpdate(nextProps) {
    if (this.props.chat && nextProps.chat &&
      this.props.chat.id !== nextProps.chat.id) {
      this.setState(this.getInitialState());
    }
  },

  shouldHideToastsFn() {
    return !Modal.getCurrent();
  },

  renderParticipantNames() {
    const names = this.props.chat.getDisplayNames();
    return (
      <Text size="large" truncate>
        <HumanArray sample={names} total={names.length} />
      </Text>
    );
  },

  render() {
    const { chat, title, subtitle } = this.props;
    const partnerLeft = chat && chat.isPresent() && !!this.props.chat.getLeftMemberships()[0];
    let participantNames = null;
    const titleTextSize = subtitle ? 'medium' : 'large';

    if (this.props.chat && !title) {
      participantNames = (
        <Text size={titleTextSize} truncate>
          {this.props.chat.hasTitle() ?
            this.props.chat.getTitle() :
            this.renderParticipantNames()
          }
        </Text>
      );
    }
    const titleText = (
      <Text size={titleTextSize} truncate>
        {title}
      </Text>
    );

    let linkedTitle = title ? titleText : participantNames;
    if (this.props.onTitleClicked) {
      linkedTitle = (
        <Link color="pitch" onClick={this.props.onTitleClicked}>
          {linkedTitle}
        </Link>
      );
    }


    const subtitleText = (
      <Text
        className="ConversationHeader-subtitle"
        size="xsmall"
        truncate>
        {subtitle}
      </Text>
    );

    return (
      <div
        className={cx({
          ConversationHeader: true,
          'ConversationHeader-disabled': (chat && chat.isUnsubscribed()) || partnerLeft,
        })}>
        <div className="ConversationHeader-titles">
          <h1
            className={cx('ConversationHeader-title', {
              'ConversationHeader-title-shiftUp': subtitle,
            })}>
            {linkedTitle}
          </h1>
          {subtitle && subtitleText}
        </div>
        <div className="ConversationHeader-buttons">
          {this.props.children}
        </div>
      </div>
    );
  },
});

export default ConversationHeader;



// WEBPACK FOOTER //
// ./src/chat/components/ConversationHeader.jsx